import { Button, ButtonProps, ExternalLinkSVG, Icon } from "@newsela/angelou";
import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";
import { normalizeLTILaunchUrl } from "@/view/ArticleActivityPicker/utils/normalizeLTILaunchUrl/normalizeLTILaunchUrl";
import {
  buttonCss,
  ctaContainer,
  headlineCss,
  headlineContainerCss,
  iconCss,
  curatedFormativeConnectionOption,
  curatedFormativeConnectionOptionsCss,
} from "./CuratedFormativeOption.style";

interface CuratedFormativeOptionProps {
  contentId: string;
  cta: {
    headline: string;
    body: string;
    url: string;
  };
  data: {
    url?: string;
    payload?: string;
  };
  streamName?: "SCIENCE" | "SOCIAL_STUDIES";
}

const ButtonWithTrackEvent = withTrackEvent<ButtonProps>(Button);

const CuratedFormativeOption = ({
  contentId,
  cta,
  data,
  streamName,
}: CuratedFormativeOptionProps) => {
  if (!cta) {
    return null;
  }

  const scienceOptions = ["Drag & Drop", "Multiple Selection", "Categorize"];
  const socialStudiesOptions = [
    "Multiple Choice",
    "Multiple Selection",
    "Categorize",
  ];

  const curatedConnectionOptions = {
    SCIENCE: scienceOptions,
    SOCIAL_STUDIES: socialStudiesOptions,
  };

  const eventProperties = {
    objectType: objectTypes.user,
    actionName: actionNames.navigate,
    streamProperties: {
      description: cta.headline,
      content_id: contentId,
    },
  };

  const launchUrl = normalizeLTILaunchUrl(cta?.url);

  return (
    <form method="post" action={launchUrl} target="_blank" role="form">
      <input name="id_token" type="hidden" value={data?.payload ?? ""} />
      <ButtonWithTrackEvent
        __cssFor={{ root: buttonCss, Icon: { root: iconCss } }}
        ariaProps={{
          "aria-label": `${cta.headline}. Opens in new tab`,
        }}
        dataProps={{
          "data-qa-selector": "curated-formative-activity-panel-link",
        }}
        flavor={Button.flavors.muted}
        type="submit"
        {...eventProperties}
      >
        <div css={ctaContainer}>
          <div css={headlineContainerCss}>
            <div>
              <h4 css={headlineCss}>{cta.headline}</h4>
              {cta.body && (
                <span css={headlineCss}>
                  by <strong>Newsela Staff</strong>
                </span>
              )}
            </div>
            <Icon
              __cssFor={{ root: iconCss }}
              SvgComponent={ExternalLinkSVG}
              size={Icon.sizes.sm}
            />
          </div>
          {streamName &&
            (curatedConnectionOptions[streamName]?.length ?? 0) > 0 && (
              <div css={curatedFormativeConnectionOptionsCss}>
                {(curatedConnectionOptions[streamName] ?? []).map(
                  (option, index) => (
                    <div css={curatedFormativeConnectionOption} key={index}>
                      {option}
                    </div>
                  ),
                )}
              </div>
            )}
        </div>
      </ButtonWithTrackEvent>
    </form>
  );
};

export default CuratedFormativeOption;
